import styled from 'styled-components';

const DivLoader = styled.div`
  width: fit-content;
  margin: 100px auto;
`;

export default DivLoader;
